export default __webpack_public_path__ + "static/media/emoji_thumbsup.aab83a4c.svg";